import {
  Control,
  FieldErrors,
  UseFormClearErrors,
  UseFormGetValues,
  UseFormRegister,
  UseFormSetValue,
} from "react-hook-form";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import APIS from "../../constant/Endpoint";
import ComboboxInput from "../Reusable/ComboboxInput";
import MultipleSelectField from "../Reusable/MultipleSelectField";
import { RichTextEditor } from "../Reusable/RichTextEditor";
import TextField from "../Reusable/TextField";
import ImageField from "../Reusable/ImageField";
import { IPostSchema } from "../../utils/validationSchema";

interface Props {
  register: UseFormRegister<IPostSchema>;
  setValue: UseFormSetValue<IPostSchema>;
  getValues: UseFormGetValues<IPostSchema>;
  errors: FieldErrors<IPostSchema>;
  clearErrors?: UseFormClearErrors<IPostSchema>;
  control: Control<IPostSchema>;
  data?: IPostSchema | null;
}

const CreatePostForm = ({
  register,
  errors,
  setValue,
  getValues,
  clearErrors,
  control,
  data = null,
}: Props) => {
  return (
    <div
      className={tw`grid grid-cols-2 gap-x-5 pl-4`}
      style={{
        gridTemplateColumns: "2fr 1fr",
      }}
    >
      <div className={tw`h-fit `}>
        <TextField
          placeholder="Enter title"
          type="text"
          label="Title"
          register={register("headline", {
            required: "Headline is required",
          })}
          errors={errors.headline}
        />
        <RichTextEditor
          register={register("content")}
          setValue={setValue}
          errors={errors.content}
          label="Content"
          control={control}
          name="content"
        />
      </div>
      <div className={tw`border-l px-3`}>
        <ComboboxInput
          url={APIS.BLOG_AUTHOR}
          queryKey={"blog-author"}
          errors={errors?.author}
          name={"author"}
          label={"Author"}
          setValue={setValue}
          placeholder={"Select Author"}
          getValues={getValues}
          clearErrors={clearErrors}
          displayKey="display_name"
        />
        <MultipleSelectField
          register={register("category")}
          setValue={setValue}
          label={"Category"}
          queryKey={"blog-category"}
          url={APIS.BLOG_CATEGORY}
          placeholder={"Select Category"}
          getValues={getValues}
          clearErrors={clearErrors}
          errors={errors.category}
          control={control}
          name="category"
          value={
            data?.category
              ? data.category.map((item) => ({
                  //@ts-ignore
                  label: item.name,
                  //@ts-ignore
                  value: item.id,
                }))
              : []
          }
        />

        <MultipleSelectField
          url={APIS.BLOG_TAG}
          queryKey={"blog-tags"}
          register={register("tag")}
          label={"Tags"}
          setValue={setValue}
          placeholder={"Select Tags"}
          getValues={getValues}
          clearErrors={clearErrors}
          errors={errors.tag}
          control={control}
          name="tag"
          value={
            data?.tag
              ? data.tag.map((item) => ({
                  //@ts-ignore
                  label: item.name,
                  //@ts-ignore
                  value: item.id,
                }))
              : []
          }
        />
        <ImageField
          label="Preview Image"
          name="preview_image"
          control={control}
        />
      </div>
    </div>
  );
};

export default CreatePostForm;
